import { createAction } from "redux-starter-kit";
import UserInfo from "./UserInfo";

export const getMeFetch = createAction("user/getMeFetch");
export const getMeFetchCancel = createAction("user/getMeFetchCancel");
export const getMeFetchSuccess = createAction<UserInfo>(
  "user/getMeFetchSuccess"
);
export const getMeFetchRejected = createAction("user/getMeFetchRejected");

const logicActions = {
  getMeFetch,
  getMeFetchCancel,
  getMeFetchSuccess,
  getMeFetchRejected,
};

export default logicActions;
